import React from 'react';

function MultiPartQuestion({ question, value, onChange }) {
  const handlePartChange = (partId, partValue) => {
    onChange({
      ...value,
      [partId]: partValue
    });
  };

  return (
    <div>
      {question.parts.map((part, index) => (
        <div key={part.id} className="part-section">
          <div className="part-label">{part.label}</div>
          <div className="options-container">
            {part.options.map(option => (
              <div
                key={option.value}
                className={`option-item ${value[part.id] === option.value ? 'selected' : ''}`}
                onClick={() => handlePartChange(part.id, option.value)}
              >
                <input
                  type="radio"
                  name={part.id}
                  value={option.value}
                  checked={value[part.id] === option.value}
                  onChange={() => handlePartChange(part.id, option.value)}
                />
                <span className="option-label">{option.label}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default MultiPartQuestion;
